/* Loaded Concept, 2026-10-10. Player for the Studio hero video section (sections/kgs-studio-hero.liquid).
   A custom element, so it also starts when the theme editor re-renders the section.
   Wrapped so the file can load once per section without redeclaring anything. */
(() => {
  if (customElements.get('kgs-hero-player')) return;

  class KgsHeroPlayer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) {
        // Moved in the page: pick the observers back up.
        if (this.nearObserver) this.nearObserver.observe(this);
        if (this.viewObserver) this.viewObserver.observe(this);
        return;
      }
      this.dataset.ready = 'true';

      const video = this.querySelector('.kgs-hero__video');
      const toggle = this.querySelector('.kgs-hero__toggle');
      if (!video || !toggle) return;

      const phone = window.matchMedia('(max-width: 767.98px)').matches;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const data = video.dataset;
      const src = (phone && data.srcMobile) || data.srcDesktop || data.srcMobile;
      const poster = (phone && data.posterMobile) || data.posterDesktop || data.posterMobile;
      const lazy = this.dataset.start === 'scroll';
      if (poster && !lazy) video.poster = poster;
      if (!src) {
        toggle.hidden = true;
        return;
      }

      // Whether the video should be playing when it is on screen: yes by default,
      // no under reduced motion until the visitor presses Play, and no after they press pause.
      let wanted = !reduce;
      const sync = () => {
        toggle.classList.toggle('is-paused', video.paused);
        toggle.setAttribute('aria-label', video.paused ? 'Play the studio video' : 'Pause the studio video');
      };
      const load = () => {
        if (video.getAttribute('src')) return;
        if (poster && lazy) video.poster = poster;
        video.preload = 'auto';
        video.src = src;
      };
      const play = () => {
        load();
        const started = video.play();
        if (started && started.catch) started.catch(sync);
      };

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      toggle.addEventListener('click', () => {
        wanted = video.paused;
        if (wanted) play();
        else video.pause();
      });

      sync();
      if (!('IntersectionObserver' in window)) {
        if (wanted) play();
        return;
      }

      // "Scroll" sections start downloading when they are about 300px below the screen,
      // so the video is ready by the time it appears.
      if (lazy) {
        if (wanted) {
          this.nearObserver = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              load();
              this.nearObserver.disconnect();
            }
          }, { rootMargin: '300px 0px' });
          this.nearObserver.observe(this);
        }
      } else if (wanted) {
        load();
      }

      // Play while on screen, pause while off screen.
      this.viewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (wanted) play();
          } else if (!video.paused) {
            video.pause();
          }
        });
      });
      this.viewObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.nearObserver) this.nearObserver.disconnect();
      if (this.viewObserver) this.viewObserver.disconnect();
    }
  }

  customElements.define('kgs-hero-player', KgsHeroPlayer);
})();
